import React, { Component } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimesCircle } from "@fortawesome/free-solid-svg-icons";

import withSpellcheck from "../../../../form-inputs/shared/spell-check";

import { Typeahead } from "../../../../form-inputs/typeahead";
import { InputList, Textarea } from "../../../../form-inputs/inputs";

const SpellCheckInputList = withSpellcheck(InputList);

class Warning extends Component {
    constructor(props) {
        super();
        this.state = {
            ...props.data,
        };
    }

    onWarningSelect = (key, selected) => {
        this.setState({
            type: selected.value,
            code: selected.code,
            text: selected.placeHolderText,
        });
        this.props.updateOnChange({
            ...this.state,
            type: selected.value,
            text: selected.placeHolderText,
        });
    };

    updateField = (key, value) => {
        this.setState({
            [key]: value,
        });

        this.props.updateOnChange({
            ...this.state,
            [key]: value,
        });
    };

    removeItem = () => {
        this.props.removeItem("warnings", this.props.id);
    };

    render() {
        return (
            <div className="warning-block drug-item">
                <Typeahead
                    id={`warningType_${this.props.id}`}
                    name="warningType"
                    label="Prefill Options"
                    value={this.state.type}
                    updateOnChange={this.onWarningSelect}
                    options={this.props.warningList}
                    clearOnSelect={true}
                />
                <br />
                <Textarea
                    id={`text_${this.props.id}`}
                    name="text"
                    label="Warning Text"
                    value={this.state.text}
                    updateOnChange={this.updateField}
                />
                <SpellCheckInputList
                    id={`bullets_${this.props.id}`}
                    name="bullets"
                    label="Warnings"
                    defaultValue={this.state.bullets}
                    updateOnChange={this.updateField}
                    validation={{ type: "StringList" }}
                />
                <div
                    className="close"
                    onClick={this.removeItem}
                >
                    <FontAwesomeIcon icon={faTimesCircle} />
                </div>
            </div>
        );
    }
}

export default Warning;
